var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_10632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0157 5.36453L9.96333 1.43041C10.1789 1.20137 10.1789 0.851063 9.96333 0.635482C9.74776 0.419917 9.38398 0.419917 9.1684 0.635482L5.62495 4.17893L2.08149 0.635482C1.85244 0.419917 1.50219 0.419917 1.28656 0.635482C1.07101 0.851048 1.07101 1.20135 1.28656 1.43041L5.2207 5.36453C5.44974 5.5801 5.80012 5.5801 6.0157 5.36453Z",
    fill: "#F86557"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_10632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9.75,
    fill: "white",
    transform: "matrix(0 1 -1 0 10.5 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.fb43cfd7c04b54987373051296e2b7b1.svg";
export { ForwardRef as ReactComponent };